import * as yup from 'yup';

export const reservationValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Nome da reserva é obrigatório')
    .min(3, 'Nome deve ter pelo menos 3 caracteres'),
  start_date: yup
    .string()
    .required('Data de início é obrigatória'),
  end_date: yup
    .string()
    .required('Data de fim é obrigatória'),
  room_id: yup
    .string()
    .required('Área/Sala é obrigatória'),
  tenant_id: yup
    .string()
    .required('Empresa é obrigatória'),
  user_id: yup
    .string()
    .required('Responsável é obrigatório'),
});